var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_257_646)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16V16ZM8.252 3.068C8.19528 3.03263 8.13177 3.00956 8.06557 3.00026C7.99937 2.99096 7.93196 2.99566 7.86769 3.01403C7.80342 3.03241 7.74372 3.06406 7.69244 3.10695C7.64117 3.14983 7.59945 3.20299 7.57 3.263L6.37 5.695L3.686 6.085C3.59751 6.09756 3.51431 6.13468 3.44585 6.19215C3.37739 6.24962 3.32642 6.32513 3.29872 6.41011C3.27102 6.49509 3.2677 6.58613 3.28913 6.6729C3.31057 6.75968 3.35591 6.8387 3.42 6.901L5.364 8.793L4.904 11.467C4.88884 11.555 4.89862 11.6454 4.93223 11.7281C4.96584 11.8108 5.02194 11.8825 5.09418 11.9349C5.16641 11.9874 5.25189 12.0186 5.34094 12.025C5.42998 12.0313 5.51903 12.0126 5.598 11.971L8 10.709L10.4 11.97C10.479 12.0116 10.568 12.0303 10.6571 12.024C10.7461 12.0176 10.8316 11.9864 10.9038 11.9339C10.9761 11.8815 11.0322 11.8098 11.0658 11.7271C11.0994 11.6444 11.1092 11.554 11.094 11.466L10.636 8.793L12.578 6.9C12.6414 6.83757 12.6862 6.75871 12.7073 6.67226C12.7284 6.58582 12.725 6.4952 12.6974 6.41058C12.6699 6.32596 12.6194 6.25067 12.5515 6.19317C12.4836 6.13566 12.401 6.09821 12.313 6.085L9.628 5.695L8.428 3.263C8.3887 3.18284 8.32773 3.11529 8.252 3.068V3.068Z",
    fill: "#0049C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_257_646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthTagIcon);
export default __webpack_public_path__ + "static/media/auth_tag_icon.5fa63c622a14cf0d3096aeab75e2769d.svg";
export { ForwardRef as ReactComponent };